import { LoadingButton } from '@mui/lab';
import { Alert, Link, Stack, Typography } from '@mui/material';
import { TwoFactoryCheckForm, TwoFactoryForm } from 'app/pages/TwoFactory';
import { useAsyncAction } from 'app/services';
import { sessionCheck2Fa, sessionReset2Fa, sessionSetup2Fa } from 'app/store/session';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink, Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
const TwoFactory = () => {
    const formRef = useRef(null);
    const { secret } = useSelector((state) => state.session);
    const { asyncAction: submitSetup, isLoading: isSetupLoading } = useAsyncAction(sessionSetup2Fa);
    const { asyncAction: submitCheck, isLoading: isCheckLoading, isError: isCheckError } = useAsyncAction(sessionCheck2Fa);
    const { asyncAction: reset } = useAsyncAction(sessionReset2Fa);
    const { path } = useRouteMatch();
    const handleClickNext = () => {
        submitSetup();
    };
    const handleClickBack = () => {
        reset();
    };
    const handleClickForm = () => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleSubmitForm();
    };
    const handleSubmitForm = (params) => {
        submitCheck(params.code);
    };
    const handleLogKey = (e) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            e.preventDefault();
            handleClickForm();
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', handleLogKey);
        return () => {
            document.removeEventListener('keydown', handleLogKey);
        };
    }, []);
    if (!secret) {
        return React.createElement(Redirect, { to: '/' });
    }
    if (secret.setupQrCode) {
        if (path !== '/account/check-2fa') {
            return React.createElement(Redirect, { to: '/account/check-2fa' });
        }
    }
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: '/account/setup-2fa' },
            React.createElement(Stack, { direction: 'row', flexDirection: 'column', sx: (theme) => ({
                    paddingBottom: theme.spacing(2),
                    '.MuiTypography-h5': {
                        marginBottom: theme.spacing(1),
                    },
                    '.MuiTypography-body2': {
                        color: theme.palette.text.secondary,
                    },
                }) },
                React.createElement(Typography, { variant: 'h5' }, "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430\u044F \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F"),
                React.createElement(Typography, { variant: 'body2' }, "\u041E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u042F\u043D\u0434\u0435\u043A\u0441 \u041A\u043B\u044E\u0447 \u0438\u043B\u0438 \u042F\u043D\u0434\u0435\u043A\u0441 ID QR-\u043A\u043E\u0434 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u044B\u0439 \u043A\u043B\u044E\u0447, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u043D\u0438\u0436\u0435 \u0432\u0440\u0443\u0447\u043D\u0443\u044E. \u0427\u0442\u043E\u0431\u044B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443\u044E \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0443 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F.")),
            React.createElement(TwoFactoryForm, { secretKey: secret.key, qrCode: secret.qr }),
            React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'flex-start', spacing: 2, sx: (theme) => ({
                    marginTop: theme.spacing(3),
                    '.MuiLoadingButton-root': {
                        lineHeight: '22px',
                        padding: theme.spacing(2),
                    },
                    '.MuiAlert-root': {
                        width: '100%',
                        marginBottom: theme.spacing(2),
                        borderRadius: theme.shape.borderRadius,
                    },
                }) },
                React.createElement(LoadingButton, { variant: 'contained', onClick: handleClickNext, loading: isSetupLoading, fullWidth: true, disableElevation: true }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"),
                React.createElement(Typography, { variant: 'body2' },
                    React.createElement(Link, { to: '#', variant: 'subtitle2', underline: 'none', onClick: handleClickBack, component: RouterLink }, "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0432\u0445\u043E\u0434\u0443")))),
        React.createElement(Route, { exact: true, path: '/account/check-2fa' },
            React.createElement(Stack, { direction: 'row', flexDirection: 'column', sx: (theme) => ({
                    paddingBottom: theme.spacing(2),
                    '.MuiTypography-h5': {
                        marginBottom: theme.spacing(1),
                    },
                    '.MuiTypography-body2': {
                        color: theme.palette.text.secondary,
                    },
                }) },
                React.createElement(Typography, { variant: 'h5' }, "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430\u044F \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F"),
                React.createElement(Typography, { variant: 'body2' }, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u044B\u0439 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0438\u0437 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u042F\u043D\u0434\u0435\u043A\u0441 \u041A\u043B\u044E\u0447 \u0438\u043B\u0438 \u042F\u043D\u0434\u0435\u043A\u0441 ID QR-\u043A\u043E\u0434, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0435\u0433\u043E \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438.")),
            React.createElement(TwoFactoryCheckForm, { ref: formRef, onSubmit: handleSubmitForm }),
            React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'flex-start', spacing: 2, sx: (theme) => ({
                    marginTop: theme.spacing(3),
                    '.MuiLoadingButton-root': {
                        lineHeight: '22px',
                        padding: theme.spacing(2),
                    },
                    '.MuiAlert-root': {
                        width: '100%',
                        marginBottom: theme.spacing(2),
                        borderRadius: theme.shape.borderRadius,
                    },
                }) },
                isCheckError && (React.createElement(Alert, { severity: 'error' }, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u043D\u0430\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u043A\u043E\u0434\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F.")),
                React.createElement(LoadingButton, { variant: 'contained', loading: isCheckLoading, onClick: handleClickForm, fullWidth: true, disableElevation: true }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"),
                React.createElement(Typography, { variant: 'body2' },
                    React.createElement(Link, { to: '#', variant: 'subtitle2', underline: 'none', onClick: handleClickBack, component: RouterLink }, "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0432\u0445\u043E\u0434\u0443"))))));
};
export default TwoFactory;
